import { LOCATION_CHANGE } from 'react-router-redux';

import { BackstageActionTypes, ExternalActions } from '../../constants';
import * as D from '../../deps';
import * as BackstageWorkers from '../workers';

export default [
  {
    actionType: BackstageActionTypes.GET_CATALOG_DETAILS_FOR_BACKSTAGE,
    handler: BackstageWorkers.getCatalogDetailsForBackstageWorker,
    concur: 'takeEvery',
  },
  {
    actionType: BackstageActionTypes.GET_ARTIST_DISCOGRAPHY_FOR_BACKSTAGE,
    handler: BackstageWorkers.getArtistDiscographyForBackstageWorker,
    concur: 'takeEvery',
  },
  {
    actionType: BackstageActionTypes.GET_ARTIST_DISCOGRAPHY_ANNOTATIONS,
    handler: BackstageWorkers.getArtistDiscographyAnnotationsWorker,
    concur: 'takeLatest',
  },
  {
    actionType: BackstageActionTypes.GET_ARTIST_EVENTS_FOR_BACKSTAGE,
    handler: BackstageWorkers.getArtistEventsForBackstageWorker,
    concur: 'takeEvery',
  },
  {
    actionType: BackstageActionTypes.GET_ALL_ARTIST_TRACKS_FOR_BACKSTAGE,
    handler: BackstageWorkers.getAllArtistTracksForBackstageWorker,
    concur: 'takeEvery',
  },
  {
    actionType: BackstageActionTypes.ANNOTATE_OBJECTS_FOR_BACKSTAGE,
    handler: BackstageWorkers.annotateObjectsForBackstageWorker,
    concur: 'takeEvery',
  },
  {
    actionType: BackstageActionTypes.ANNOTATE_OBJECTS_FOR_BACKSTAGE_ARTIST_ALL_SONGS,
    handler: BackstageWorkers.annotateObjectsForBackstageArtistAllSongsWorker,
    concur: 'takeEvery',
  },
  {
    actionType: LOCATION_CHANGE,
    handler: BackstageWorkers.interceptBackstageNavigation,
    concur: 'takeEvery',
  },
  {
    actionType: ExternalActions.ENTER_BACKSTAGE,
    handler: BackstageWorkers.onEnterBackstage,
    concur: 'takeEvery',
  },
  {
    actionType:
      D.Constants.Api.ApiActions.CATALOG_GET_ALL_ARTIST_TRACKS_WITH_COLLABORATIONS_SUCCESS,
    handler: BackstageWorkers.handleAllArtistTracksForBackstageAnnotationsWorker,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS,
    handler: BackstageWorkers.fetchGenreCurators,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.PLAYLISTS_GET_TRACKS_SUCCESS,
    handler: BackstageWorkers.fetchPlaylistCurator,
    concur: 'takeEvery',
  },
];
